/* unplugin-vue-components disabled */import { render } from "./Catalog.vue?vue&type=template&id=67fe4184"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__